export const isAndroid = () => /Beyond-Android/g.test(navigator.userAgent);
export const isIOS = () => /Beyond-iOS/g.test(navigator.userAgent);

export default { isAndroid, isIOS };
